/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { UpdateStaffMemberMutationRequest, UpdateStaffMemberMutationResponse, UpdateStaffMemberPathParams, UpdateStaffMember400, UpdateStaffMember401, UpdateStaffMember403, UpdateStaffMember404, UpdateStaffMember409, UpdateStaffMember500 } from "../../types/staffController/UpdateStaffMember.ts";
import type { Client, RequestConfig, ResponseErrorConfig } from "@packages/api-client/client-config";
import type { UseMutationOptions, UseMutationResult, QueryClient } from "@tanstack/react-query";
import { updateStaffMember } from "../../client/staffController/updateStaffMember.ts";
import { mutationOptions, useMutation } from "@tanstack/react-query";

export const updateStaffMemberMutationKey = () => [{ url: '/api/organizations/:organizationId/staff/:staffId' }] as const

export type UpdateStaffMemberMutationKey = ReturnType<typeof updateStaffMemberMutationKey>

export function updateStaffMemberMutationOptions<TContext = unknown>(config: Partial<RequestConfig<UpdateStaffMemberMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = updateStaffMemberMutationKey()
        return mutationOptions<UpdateStaffMemberMutationResponse, ResponseErrorConfig<UpdateStaffMember400 | UpdateStaffMember401 | UpdateStaffMember403 | UpdateStaffMember404 | UpdateStaffMember409 | UpdateStaffMember500>, {organizationId: UpdateStaffMemberPathParams["organizationId"], staffId: UpdateStaffMemberPathParams["staffId"], data: UpdateStaffMemberMutationRequest}, TContext>({
          mutationKey,
          mutationFn: async({ organizationId, staffId, data }) => {
            return updateStaffMember(organizationId, staffId, data, config)
          },
        })

}

/**
 * @summary Update staff member
 * {@link /api/organizations/:organizationId/staff/:staffId}
 */
export function useUpdateStaffMember<TContext>(options: 
{
  mutation?: UseMutationOptions<UpdateStaffMemberMutationResponse, ResponseErrorConfig<UpdateStaffMember400 | UpdateStaffMember401 | UpdateStaffMember403 | UpdateStaffMember404 | UpdateStaffMember409 | UpdateStaffMember500>, {organizationId: UpdateStaffMemberPathParams["organizationId"], staffId: UpdateStaffMemberPathParams["staffId"], data: UpdateStaffMemberMutationRequest}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<UpdateStaffMemberMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? updateStaffMemberMutationKey()

          const baseOptions = updateStaffMemberMutationOptions(config) as UseMutationOptions<UpdateStaffMemberMutationResponse, ResponseErrorConfig<UpdateStaffMember400 | UpdateStaffMember401 | UpdateStaffMember403 | UpdateStaffMember404 | UpdateStaffMember409 | UpdateStaffMember500>, {organizationId: UpdateStaffMemberPathParams["organizationId"], staffId: UpdateStaffMemberPathParams["staffId"], data: UpdateStaffMemberMutationRequest}, TContext>
          

          return useMutation<UpdateStaffMemberMutationResponse, ResponseErrorConfig<UpdateStaffMember400 | UpdateStaffMember401 | UpdateStaffMember403 | UpdateStaffMember404 | UpdateStaffMember409 | UpdateStaffMember500>, {organizationId: UpdateStaffMemberPathParams["organizationId"], staffId: UpdateStaffMemberPathParams["staffId"], data: UpdateStaffMemberMutationRequest}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<UpdateStaffMemberMutationResponse, ResponseErrorConfig<UpdateStaffMember400 | UpdateStaffMember401 | UpdateStaffMember403 | UpdateStaffMember404 | UpdateStaffMember409 | UpdateStaffMember500>, {organizationId: UpdateStaffMemberPathParams["organizationId"], staffId: UpdateStaffMemberPathParams["staffId"], data: UpdateStaffMemberMutationRequest}, TContext>
      
}